import { useSession } from '@domain/session/SessionContext';

export const useClientHasRendered = (): boolean => useSession().initialClientRenderComplete;
